import React, { useEffect } from "react";
import { Outlet, useNavigate, useParams } from "react-router-dom";
import MainNav from "./components/nav/MainNav";
import SideNav from "./components/nav/SideNav";
import styled from "styled-components";
import { RecoilRoot } from 'recoil';
import UploadProgressPortal from './components/common/UploadProgressPortal';

// 전역 스타일 추가 - body에 overflow: hidden 설정
import { createGlobalStyle } from 'styled-components';

// const GlobalStyle = createGlobalStyle`
//   body {
//     margin: 0;
//     padding: 0;
//     overflow: hidden; /* 전체 스크롤바 제거 */
//   }
// `;

const Container = styled.div`
  position: relative;
  height: 100vh; /* 화면 전체 높이로 설정 */
  overflow: hidden; /* 컨테이너 스크롤바 제거 */
`;

const MainContainer = styled.div`
  display: flex;
  // height: calc(100vh - 160px); /* 헤더 높이(160px)를 제외한 높이 */
  padding-top: 160px;
  position: relative;
  overflow: hidden; /* 메인 컨테이너 스크롤바 제거 */
`;

function App() {
  const navigate = useNavigate();
  const { gameProposalIdParam } = useParams();

  const gameProposalId = Number(gameProposalIdParam);

  useEffect(() => {
    const token = sessionStorage.getItem("token");
    if (!token) {
      navigate("/login");
    }
  }, [navigate]);

  return (
    <RecoilRoot>
      {/* <GlobalStyle /> */}
      <Container>
        <MainNav />
        <MainContainer>
          <SideNav />
          <Outlet />
        </MainContainer>
      </Container>
      <UploadProgressPortal gameProposalId={gameProposalId} />
    </RecoilRoot>
  );
}

export default App;
